import { useEffect } from "react";

import { adminSubfolderCheckBoxState } from "@keepeek/commons";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { configSectionFolderBrowseSelector } from "../selectors";

export const useInitFolderBrowseConfiguration = () => {
  const setAdminSubfolderCheckBoxState = useSetRecoilState(adminSubfolderCheckBoxState);
  const getConfigSectionFolderBrowseSelector = useRecoilValue(configSectionFolderBrowseSelector);
  useEffect(() => {
    setAdminSubfolderCheckBoxState(
      getConfigSectionFolderBrowseSelector?.automaticallyCheckSubFoldersCheckbox,
    );
  }, [
    getConfigSectionFolderBrowseSelector?.automaticallyCheckSubFoldersCheckbox,
    setAdminSubfolderCheckBoxState,
  ]);
};
